import { engineTag } from 'src/utils/engine-tag'

export default {
  setCurrentCompany ({ commit }, currentCompany) {
    commit('SET_CURRENT_COMPANY', currentCompany)

    // Tagged here rather than in MainLayout because this action is the only writer of
    // currentCompany, so the embedded widgets (HubSpot, Salesforce, standalone dialer) —
    // which never mount MainLayout — get the tag too. The company-updated broadcast also
    // re-dispatches this action, so flipping a company onto TaskRouter retags live sessions
    // without a reload.
    if (window.Sentry && currentCompany) {
      window.Sentry.setTag('engine', engineTag(currentCompany))
    }
  },

  updateCompanyFlag ({ commit }, { flag, value }) {
    commit('UPDATE_COMPANY_FLAG', { flag, value })
  },

  deleteCurrentCompany ({ commit }) {
    commit('DELETE_CURRENT_COMPANY')
  },

  setTimezones ({ commit }, value) {
    commit('SET_TIMEZONES', value)
  },

  setAgentStatuses ({ commit }, value) {
    commit('SET_AGENT_STATUSES', value)
  }
}
